/*
All Rights Reserved. Permission to use and distribute this software, source code and its documentation is hereby granted on the terms
and conditions set out in the License Agreement dated August 10, 2018 (‘License Agreement’) between Prashant Sharma and China Guangdong
Jingteng Technology Co., Ltd. This copyright notice shall appear in all copies and distributions to the extent permitted in the License
Agreement. This Software, source code and its documentation may not be used without the prior written consent of Prashant Sharma in any
manner whatsoever except to the extent specified in the License Agreement. Contact Prashant Sharma, B-801, Purva Panorama, Bannerghatta Road,
Bangalore – 560 076, +91 9731217354, spidersharma@gmail.com for any queries on this Software.

IN NO EVENT SHALL PRASHANT SHARMA BE LIABLE TO ANY PARTY FOR DIRECT, INDIRECT, SPECIAL, INCIDENTAL, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST
PROFITS, ARISING OUT OF THE USE OF THIS SOFTWARE AND ITS DOCUMENTATION, EVEN IF PRASHANT SHARMA HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH
DAMAGE.
PRASHANT SHARMA SPECIFICALLY DISCLAIMS ANY WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS
FOR A PARTICULAR PURPOSE. THE SOFTWARE AND ACCOMPANYING DOCUMENTATION, IF ANY, PROVIDED HEREUNDER IS PROVIDED "AS IS". PRASHANT SHARMA HAS
NO OBLIGATION TO PROVIDE UPDATES, ENHANCEMENTS, OR MODIFICATIONS AND WILL, HOWEVER, PROVIDE TRAINING AND MAINTENANCE TO THE EXTENT AND FOR
THE FEES AS SET OUT IN SCHEDULE B TO THE LICENSE AGREEMENT.
*/
/* 
Also there is a way to set diamond config using::
  IJEWEL.DiamondUtils.setGemstoneConfig(config) method
where config is something like::
  let config = {
      diamondClass : [
          {name: "diamond", color: 0xffffff },
          {name: "ruby", color: 0xffffff }
      ],
      diamondConfiguration: [
          {name: "Diamond_Large035", color: 0xffffff },
          {name: "diamond1", color: 0xffffff },
      ]
  };
without config it will assume that the naming is "Diamond"(the earlier behaviour)
*/

import {
  Color
} from "three";

import {
  DiamondMaterial,
  Diamond
} from './Diamond';

let DiamondUtils = {};

DiamondUtils.processScene = function (renderer, scene, configurationParams) {
  DiamondUtils.prototypeMaterials = [];
  findDiamondPrototypes(scene, configurationParams);
  return buildDiamondScene(renderer, scene, configurationParams);
};

DiamondUtils.setGemstoneConfig = function (diamonds, configurationParams) {

  let envCubeMap = configurationParams && configurationParams.envCubeMap;

  diamonds.forEach(diamond => {
    const mesh = diamond.getMesh();
    if (mesh.isMesh) {
      if (mesh.material && envCubeMap) {
        mesh.material.uniforms.envMap.value = envCubeMap;
        mesh.material.envMap = envCubeMap;
      }

      const filter1 = classFilter(mesh, configurationParams);
      const filter2 = objectFilter(mesh, configurationParams);
      let filterName = filter1 && filter1.name;
      filterName = filterName || (filter2 && filter2.name)
      if (filterName) {
        const filter_ = filter2 || filter1;
        applyGemParams(mesh, filter_);
      }
    }
  });
};

function findDiamondPrototypes(scene, configurationParams) {
  let enableParentObjFind = configurationParams.enableParentObjFind;
  scene.traverse((object) => {
    let objName = object.name.toLowerCase();
    if(enableParentObjFind){
      if(objName.includes("diamond") && object.children.length && object.children[0].isMesh){
        let childObj = object.children[0];
        const filter = classFilter(object, configurationParams) || objectFilter(object, configurationParams);
        const filterName = filter && filter.name;
        if (filterName) {
          if (!DiamondUtils.prototypeMaterials[filterName]) {
            DiamondUtils.prototypeMaterials[filterName] = childObj;
          }
        }
      }
    }else if (object.isMesh) {
      const filter = classFilter(object, configurationParams) || objectFilter(object, configurationParams);
      const filterName = filter && filter.name;
      if (filterName) {
        if (!DiamondUtils.prototypeMaterials[filterName]) {
          DiamondUtils.prototypeMaterials[filterName] = object;
        }
      }
    }
  });
}

function classFilter(object, configurationParams) {
  let out;
  const objectName = object.name.toLowerCase();
  if (configurationParams && configurationParams.diamondClass) {
    const diamondClassList = configurationParams.diamondClass;
    for (let key in diamondClassList) {
      let diamondClassConfig = diamondClassList[key];
      if (diamondClassConfig.name && objectName.includes(diamondClassConfig.name.toLowerCase())) {
        // 只取第一个
        return diamondClassConfig;
      }
    }
  } else {
    if (configurationParams && !configurationParams.diamondConfiguration && objectName.includes("diamond")) {
      out = {
        name: object.name.substring(0, 8)
      };
    }
  }
  return out;
}

function objectFilter(object, configurationParams) {
  configurationParams = configurationParams;
  let out;
  const objectName = object.name.toLowerCase();
  if (configurationParams && configurationParams.diamondConfiguration) {
    const diamondConfigs = configurationParams.diamondConfiguration;
    for (let key in diamondConfigs) {
      let diamondConfig = diamondConfigs[key];
      if (diamondConfig.name && objectName === diamondConfig.name.toLowerCase()) {
        return diamondConfig;
      }
    }
  } else {
    if (objectName.includes("diamond")) {
      out = {
        name: "diamond"
      };
    }
  }
  return out;
}

function buildDiamondScene(renderer, scene, configurationParams) {
  let diamonds = [];
  let enableParentObjFind = configurationParams.enableParentObjFind;
  let envCubeMap = configurationParams && configurationParams.envCubeMap;
  for (var key in DiamondUtils.prototypeMaterials) {
    const mesh = DiamondUtils.prototypeMaterials[key];
    const diamondMaterialPrototype = new DiamondMaterial(mesh, envCubeMap, renderer);
    DiamondUtils.prototypeMaterials[key] = diamondMaterialPrototype;
  }

  scene.updateMatrixWorld();
  scene.traverse((object) => {
    let objName = object.name.toLowerCase();
    if(enableParentObjFind){
      if(objName.includes("diamond") && object.children.length && object.children[0].isMesh){
        let childObj = object.children[0];
        if (childObj.material) {
          childObj.material.envMap = envCubeMap;
        }
        const filter1 = classFilter(object, configurationParams);
        const filter2 = objectFilter(object, configurationParams);
        let filterName = filter1 && filter1.name;
        filterName = filterName || (filter2 && filter2.name);
        if (filterName) {
          if (DiamondUtils.prototypeMaterials[filterName]) {
            let diamondMaterial = DiamondUtils.prototypeMaterials[filterName];
            const diamond = new Diamond(childObj, diamondMaterial);
            const filter_ = filter2 || filter1;
            applyGemParams(childObj, filter_);
            diamonds.push(diamond);
          }
        }
      }
    }else if (object.isMesh) {
      if (object.material) {
        object.material.envMap = envCubeMap;
      }
      const filter1 = classFilter(object, configurationParams);
      const filter2 = objectFilter(object, configurationParams);
      let filterName = filter1 && filter1.name;
      filterName = filterName || (filter2 && filter2.name);
      if (filterName) {
        if (DiamondUtils.prototypeMaterials[filterName]) {
          let diamondMaterial = DiamondUtils.prototypeMaterials[filterName];
          const diamond = new Diamond(object, diamondMaterial);
          const filter_ = filter2 || filter1;
          applyGemParams(object, filter_);
          diamonds.push(diamond);
        }
      }
    }
  });
  return diamonds;
}

function setConfiguration(configuration) {
  this.gltf.scene.traverse((object) => {
    if (object.isMesh) {
      if (object.material) {
        object.material.envMap = configurationParams.envCubeMap;
      }

      const filter1 = this.classFilter(object);
      const filter2 = this.objectFilter(object);
      let filterName = filter1 && filter1.name;
      filterName = filterName || (filter2 && filter2.name)
      if (filterName) {
        const filter_ = filter2 || filter1;
        this.applyGemParams(object, filter_);
        this.diamonds.push(object);
      }
    }
  });
}

function applyGemParams(mesh, gemParams) {
  const material = mesh.material;
  const absorbption = material.uniforms["Absorbption"].value;
  if (gemParams.color !== undefined) {
    const color = new Color(gemParams.color);
    absorbption.x = 1.0 - color.r;
    absorbption.y = 1.0 - color.g;
    absorbption.z = 1.0 - color.b;
  }
  material.needsUpdate = true;
}


export {
  DiamondUtils
};